import React from "react";
import classes from "./styles.module.scss";
import { Desk, EventSpace, Icon, MeetingRoom, Office } from "Components/Icons";
import { Info } from "Components/Icons";
import useUniqueId from "Hooks/useUniqueId";
import { UncontrolledTooltip } from "Components/ReactstrapSlim";
import { DesignContextProvider } from "Components/DesignContext";

interface ItemProps {
   title: string;
   description: string;
   icon: Icon;
}

const Item: React.FC<ItemProps> = ({ icon, title, description }) => {
   return <div className={classes.item}>
      {React.createElement(icon, { className: classes.icon })}
      <div className={classes.text}>
         <div className={classes.title}>
            {title}
         </div>
         <div className={classes.description}>
            {description}
         </div>
      </div>
   </div>
}

interface SpaceTypeExplainerTooltipProps {

}

const SpaceTypeExplainerTooltip: React.FC<SpaceTypeExplainerTooltipProps> = () => {
   const infoIconId = useUniqueId("chav-info-icon-");
   return <>
      <Info id={infoIconId} className={classes.infoIcon} />
      <UncontrolledTooltip placement="right-start" target={infoIconId} autohide={false} hideArrow innerClassName={classes.tooltipContent} >
         <DesignContextProvider name="primary">
            <div className={classes.container}>
               <Item icon={Desk} title="Desk" description="Workstation in a shared space" />
               <Item icon={Office} title="Office" description="Private workspace for teams or individuals." />
               <Item icon={MeetingRoom} title="Meeting Room" description="Private space for discussions, available for hourly or day use." />
               <Item icon={EventSpace} title="Event Space" description="Large space for various meetings, functions and events." />
            </div>
         </DesignContextProvider>
      </UncontrolledTooltip>
   </>
}

export default SpaceTypeExplainerTooltip;